import React from "react";
import { Box, Skeleton } from "@mui/material";

export const RowsSkeleton = ({
  numberOfRows = 3,
  rowGap = 3,
  rowHeight = 70,
  disablePadding = false,
  ...props
}) => {
  return (
    <Box
      padding={!disablePadding && 3}
      display="flex"
      flexDirection="column"
      gap={rowGap}
      {...props}
    >
      {new Array(numberOfRows).fill(null).map((_, index) => (
        <Skeleton key={index} variant="rect" height={rowHeight} />
      ))}
    </Box>
  );
};

export default RowsSkeleton;
